import api from './api';

export const campaignService = {
  // Get all campaigns (admin view - includes inactive and out-of-window ones)
  getAllCampaigns: async (params = {}) => {
    const response = await api.get('/admin/campaigns', { params });
    return response.data.data;
  },

  // Get campaign by ID, with its selected products
  getCampaignById: async (campaignId) => {
    const response = await api.get(`/admin/campaigns/${campaignId}`);
    return response.data.data.campaign;
  },

  // Create campaign (supports both FormData and regular JSON)
  createCampaign: async (campaignData) => {
    const isFormData = campaignData instanceof FormData;

    const config = {
      headers: isFormData
        ? {
            // Don't set Content-Type for FormData - let browser set it with boundary
          }
        : {
            'Content-Type': 'application/json',
          },
    };

    const response = await api.post('/admin/campaigns', campaignData, config);
    return response.data.data;
  },

  // Update campaign (supports both FormData and regular JSON)
  updateCampaign: async (campaignId, campaignData) => {
    const isFormData = campaignData instanceof FormData;

    const config = {
      headers: isFormData
        ? {
            // Don't set Content-Type for FormData - let browser set it with boundary
          }
        : {
            'Content-Type': 'application/json',
          },
    };

    const response = await api.put(`/admin/campaigns/${campaignId}`, campaignData, config);
    return response.data.data;
  },

  // Delete campaign (its product selections cascade away)
  deleteCampaign: async (campaignId) => {
    const response = await api.delete(`/admin/campaigns/${campaignId}`);
    return response.data;
  },
};
